import { createSlice } from "@reduxjs/toolkit";
import { welcomeEmailListAPI } from "../../services/welcomeEmailList";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const welcomeEmailListSlice = createSlice({
  name: "welcomeEmailList",
  initialState: data,
  reducers: {
    welcomeEmailInfo(state) {
      state.isLoading = true;
    },
    welcomeEmailSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    welcomeEmailFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    welcomeEmailReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const welcomeEmailListHandler = (data) => async (dispatch) => {
  try {
    dispatch(welcomeEmailAction.welcomeEmailInfo());
    const response = await welcomeEmailListAPI(data);
    dispatch(welcomeEmailAction.welcomeEmailSuccess(response));
  } catch (e) {
    dispatch(welcomeEmailAction.welcomeEmailFailure(e));
  }
};
export default welcomeEmailListSlice.reducer;
export const welcomeEmailAction = welcomeEmailListSlice.actions;
